import { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import { AppProvider } from "./store/AppStore";
import { bootstrapCatalog, hydrateFromCache } from "./lib/catalog";

// 예전에는 상품/블로그 데이터 조회가 "완전히" 끝날 때까지 상단바를 포함한
// 화면 전체를 스피너 뒤에 숨겨뒀습니다. 그래서 데이터가 늦게 오면 버튼도
// 같이 눌리지 않는 것처럼 보였습니다.
// 이제는 화면(네비게이션 바 포함)을 항상 즉시 그리고, 데이터는 뒤에서
// 채워지는 대로 필요한 부분(상품/블로그 섹션)만 알아서 갱신됩니다.
hydrateFromCache();

function App() {
  useEffect(() => {
    bootstrapCatalog();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <AppProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <Suspense
            fallback={
              <div className="min-h-screen flex items-center justify-center bg-[#0a0a0c]">
                <div className="w-8 h-8 border-2 border-white/20 border-t-primary-500 rounded-full animate-spin" />
              </div>
            }
          >
            <AppRoutes />
          </Suspense>
        </BrowserRouter>
      </AppProvider>
    </I18nextProvider>
  );
}

export default App;
